import Account from '@/pages/Account/Account/Account';
import AgentDetails from '@/pages/Agents/AgentDetailPage/AgentDetailPage';
import Agents from '@/pages/Agents/AgentListPage/Agents';
import ApiKeys from '@/pages/ApiKeys/ApiKeyListPage/ApiKeys';
import AuditLogs from '@/pages/AuditLogs/AuditLogs';
import CreateBatchCall from '@/pages/BatchCall/BatchCallCreate/CreateBatchCall';
import BatchCallDetail from '@/pages/BatchCall/BatchCallDetail/BatchCallDetail';
import BatchCalls from '@/pages/BatchCall/BatchCallList/BatchCallList';
import Calls from '@/pages/Call/CallListPage/Calls';
import Dashboard from '@/pages/Dashboard/dashboard';
import Knowledge from '@/pages/Knowledge/Knowledge';
import PhoneNumberListPage from '@/pages/PhoneNumber/PhoneNumberListPage/PhoneNumberListPage';
import Settings from '@/pages/Settings/Settings/Settings';
import Tools from '@/pages/Tools/Tools';

import { Permissions } from '@/constants';

export type AppRoute = {
  path: string;
  element: React.ComponentType;
  title: string;
  requiredPermissions?: string[];
  hideLayout?: boolean;
};

export const ROUTES: AppRoute[] = [
  {
    path: '/dashboard',
    element: Dashboard,
    title: 'Dashboard',
    requiredPermissions: [],
  },
  {
    path: '/calls',
    element: Calls,
    title: 'Calls History',
    requiredPermissions: [Permissions.CallsReadList],
  },
  {
    path: '/audit-logs',
    element: AuditLogs,
    title: 'Audit Logs',
    requiredPermissions: [Permissions.AuditLogsRead],
  },
  {
    path: '/agents',
    element: Agents,
    title: 'Agents',
    requiredPermissions: [Permissions.AgentRead],
  },
  {
    path: '/agents/:agentId',
    element: AgentDetails,
    title: 'Agent Details',
    requiredPermissions: [Permissions.AgentRead],
  },
  {
    path: '/knowledge-bases',
    element: Knowledge,
    title: 'Knowledge Bases',
    requiredPermissions: [Permissions.KnowledgeBaseRead],
  },
  {
    path: '/tools',
    element: Tools,
    title: 'Tools',
    requiredPermissions: [Permissions.ToolsRead],
  },
  {
    path: '/settings',
    element: Settings,
    title: 'Settings',
    requiredPermissions: [Permissions.UsersRead, Permissions.RolesRead],
  },
  {
    path: '/account',
    element: Account,
    title: 'Account',
    requiredPermissions: [],
  },
  {
    path: '/phone-numbers',
    element: PhoneNumberListPage,
    title: 'Phone numbers',
    requiredPermissions: [Permissions.PhoneNumberRead],
  },
  {
    path: '/keys',
    element: ApiKeys,
    title: 'API Keys',
    requiredPermissions: [Permissions.ApiKeyRead],
  },
  {
    path: '/batch-calls',
    element: BatchCalls,
    title: 'Batch Calls',
    requiredPermissions: [Permissions.BatchCallRead],
  },
  {
    path: '/batch-calls/:id',
    element: BatchCallDetail,
    title: 'Batch Call Details',
    requiredPermissions: [Permissions.BatchCallRead],
  },
  {
    path: '/batch-calls/create',
    element: CreateBatchCall,
    title: 'Create Batch Calls',
    requiredPermissions: [Permissions.BatchCallCreateUpdate],
    hideLayout: true,
  },
];

export const getPageTitle = (pathname: string): string => {
  if (pathname === '/') return 'Dashboard';

  // Try exact match first
  const exactMatch = ROUTES.find(route => route.path === pathname);
  if (exactMatch) return exactMatch.title;

  // Try dynamic route matching (e.g., /agents/:id)
  const dynamicMatch = ROUTES.find(route => {
    if (route.path.includes(':')) {
      const pattern = route.path.replace(/:[^/]+/g, '[^/]+');
      return new RegExp(`^${pattern}$`).test(pathname);
    }
    return false;
  });
  if (dynamicMatch) return dynamicMatch.title;

  return 'Dashboard';
};
